import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT =
  "paginationCustomerCampaignReceipt";
export const GET_CUSTOMER_CAMPAIGN_RECEIPT = "getCustomerCampaignReceipt";
export const FIND_CUSTOMER_CAMPAIGN_RECEIPT = "findCustomerCampaignReceipt";
export const CREATE_CUSTOMER_CAMPAIGN_RECEIPT = "createCustomerCampaignReceipt";
export const UPDATE_CUSTOMER_CAMPAIGN_RECEIPT = "updateCustomerCampaignReceipt";
export const REVERT_APPROVE_CUSTOMER_CAMPAIGN_RECEIPT =
  "revertApproveCustomerCampaignReceipt";
export const DELETE_CUSTOMER_CAMPAIGN_RECEIPT = "deleteCustomerCampaignReceipt";
export const CHECK_RECEIPT_CODE_EXIST = "checkReceiptCodeExist";

// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "customer_campaign_receipt",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "created_at",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [FIND_CUSTOMER_CAMPAIGN_RECEIPT](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`, null);
    },
    [UPDATE_CUSTOMER_CAMPAIGN_RECEIPT](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [REVERT_APPROVE_CUSTOMER_CAMPAIGN_RECEIPT](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}/revert_approve`,
        {}
      );
    },
    [CHECK_RECEIPT_CODE_EXIST](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/check_receipt_exist`, {
        params: payload
      });
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "created_at",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
